import withTranslation from '../../../globals/components/withTranslation'
import Component from './component'
import { IUserActionsProps } from './types'

export default withTranslation(Component) as React.ComponentClass<IUserActionsProps>
